import React, { useState } from "react";
import * as bip39 from "bip39";
import nacl from "tweetnacl";
import { sha256 } from "js-sha256";
import { useUnlink } from "../context/UnlinkContext";
import { storeUnlinkKeys } from "../db/KeyStorageManager";
import { usePasswordAndUserId } from "../context/AuthContext";

export default function ImportSecretView({ navigate, onBack }) {
  const sdk = useUnlink();
  const {password, userId, salt} = usePasswordAndUserId();
  const [mnemonic, setMnemonic] = useState("");
  const [error, setError] = useState("");

  const handleImport = async () => {
    try {
      const words = mnemonic.trim().toLowerCase().split(/\s+/);
      if (words.length !== 24) throw new Error("Must be 24 words");
      if (!bip39.validateMnemonic(mnemonic)) throw new Error("Invalid mnemonic");

      // recover keypair
      const keypair = await sdk.generateUnlinkKeypair(mnemonic);
      
      await storeUnlinkKeys(userId, password, salt, keypair, mnemonic);

      navigate("contacts");
    } catch {
      setError("Invalid 24-word mnemonic. Please double-check your input.");
    }
  };

  return (
    <div style={{ backgroundColor: "#000", color: "#fff", height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Sticky Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          padding: "1rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          onClick={onBack}
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            marginRight: "1rem",
            cursor: "pointer",
          }}
        >
          ←
        </button>
        <h2 style={{ margin: 0 }}>Import Identity</h2>
      </div>

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          maxWidth: "400px",
          margin: "0 auto",
        }}
      >
        <p style={{ color: "#aaa", marginBottom: "1rem", textAlign: "left" }}>
          Paste your 24-word secret phrase to recover your Unlink address.
        </p>

        <textarea
          placeholder="twelve correct horse battery staple ..."
          value={mnemonic}
          onChange={(e) => setMnemonic(e.target.value)}
          rows={4}
          style={{
            padding: "0.75rem",
            width: "100%",
            backgroundColor: "#111",
            color: "#fff",
            border: "1px solid #444",
            borderRadius: "6px",
            marginBottom: "1rem",
            resize: "none",
          }}
        />

        {error && <div style={{ color: "#f66", marginBottom: "1rem" }}>{error}</div>}

        <button
          onClick={handleImport}
          style={{
            padding: "0.5rem 1rem",
            fontSize: "1rem",
            borderRadius: "4px",
            border: "none",
            backgroundColor: "#4e8cff",
            color: "white",
            cursor: "pointer",
            width: "100%",
          }}
        >
          Import
        </button>
      </div>
    </div>
  );
}